import { createGenericApiSlice } from "../../../Api/Factory/genericApiFactory";
import { TagTypes } from "../../../Api/Types/tagTypes";
import { Category } from "../Types/category.types";

export const categoriesApi = createGenericApiSlice<Category>({
	reducerPath: "categoriesApi",
	tag: TagTypes.Category,
	endpoint: "categories",
});

export const {
	useGetAllQuery: useGetCategoriesQuery,
	useGetByIdQuery: useGetCategoryByIdQuery,
	useCreateMutation: useCreateCategoryMutation,
	useUpdateMutation: useUpdateCategoryMutation,
	useDeleteMutation: useDeleteCategoryMutation,
} = categoriesApi;
